import { render, staticRenderFns } from "./hamburger-icon.svg.vue?vue&type=template&id=48070b45&"
import script from "./hamburger-icon.svg.vue?vue&type=script&lang=js&"
export * from "./hamburger-icon.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports